export default {"src":"/_next/static/media/next_slide.af43bb5a.svg","height":30,"width":32,"blurWidth":0,"blurHeight":0};